import React from "react";
import { useAppMeta } from "hooks";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import PrepaymentForm from "./PrepaymentComponents/PrepaymentForm";
import { useGetPrepaymentDetailQuery, useUpdatePrepaymentMutation } from "store/services/PaymentsApi/prepaymentApi";



const PrepaymentEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Prepayment", path: "/app/crm/prepayment/list" },
    { title: "Edit Prepayment" },
  ];

  const {
    data: prepaymentDetail,
    isLoading: loadingPrepayment,
    error,
  } = useGetPrepaymentDetailQuery(id);

  const [updatePrepayment, { isLoading: updatingPrepayment }] =
    useUpdatePrepaymentMutation();

  const handleUpdatePrepayment = async (data) => {
    const _payload = { ...data };

    try {
      await updatePrepayment(_payload).unwrap();
      toast.success("Prepayment successfully updated!");
      navigate(`/app/crm/prepayment/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Prepayment!"
      );
    }
  };

  useAppMeta("Edit Prepayment");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingPrepayment || updatingPrepayment}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <PrepaymentForm
          isBusy={loadingPrepayment || updatingPrepayment}
          prepaymentDetail={prepaymentDetail}
          onSubmit={handleUpdatePrepayment}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default PrepaymentEditScreen;
